import axios from "axios";
export function doLogout() {
  return new Promise(function (resolve, reject) {
    let params = new URLSearchParams();
    params.append("username", localStorage.getItem("username"));
    params.append("sessionid", localStorage.getItem("sessionid"));
    axios
      .post("https://api.kings-craft.com/v1/mainSite/logout/", params)
      .then(function (res) {
        localStorage.removeItem("username");
        localStorage.removeItem("session_id");
        resolve(true);
      })
      .catch(function (err) {
        localStorage.removeItem("username");
        localStorage.removeItem("session_id");
        resolve(true); // We dont care. We still cleared the data.
      });
  });
}
export function isAutenticated() {
  return new Promise(function (resolve, reject) {
    if (
      localStorage.getItem("username") === null ||
      localStorage.getItem("session_id")
    ) {
      resolve(false);
    } else {
      let params = new URLSearchParams();
      params.append("username", localStorage.getItem("username"));
      params.append("sessionid", localStorage.getItem("sessionid"));
      axios
        .post("https://api.kings-craft.com/v1/mainSite/verifySession/", params)
        .then(function (res) {
          if (res.data.state === "success") {
            resolve(true);
          } else {
            resolve(false);
          }
        });
    }
  });
}
export function getUsername() {
  return localStorage.getItem("username");
}
export function loginVerify(username, password, captchaKey) {
  return new Promise(function (resolve, reject) {
    let params = new URLSearchParams();
    params.append("username", username);
    params.append("password", password);
    params.append("captcha_key", captchaKey);

    axios
      .post("https://api.kings-craft.com/v1/mainSite/authenticate/", params)
      .then(function (data) {
        if (data.data.state === "success") {
          localStorage.setItem("username", data.data.username);
          localStorage.setItem("sessionid", data.data.sessionid);
        }
        resolve(data);
      })
      .catch(function (error) {});
  });
}
/* loginVerify(username, password, captchaKey) {
    let xhr = new XMLHttpRequest();
    this.setState({loginMessage: "Logging in..."});
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        console.log(xhr.responseText);
        let localJson = JSON.parse(xhr.responseText);
        if (localJson.state == "error") {
          this.setState({loginMessage: localJson.error});
        } else if (localJson.state == "success") {
          this.setState({loggedState: true, username: localJson.username});

          localStorage.setItem("kcms_loggedIn", "true");
          localStorage.setItem("kcms_sessionid", localJson.sessionid);
          localStorage.setItem("kcms_userid", localJson.kcmsuserid);
          localStorage.setItem("kcms_username", localJson.username);
          this.getLoggedUserGroups();
        }
      } else if (xhr.readyState == 4 && xhr.status == 500) {
        this.setState({loginMessage: "Internal Server Error."});
      }
    };
    xhr.open("POST", "https://api.kings-craft.com/v1/kcms/login/", true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.send("username=" + username + "&password=" + password + "&captcha_key=" + captchaKey );
  } */
